import state from './moduleEventDashboardState.js'
import mutations from './moduleEventDashboardMutations.js'
import actions from './moduleEventDashboardActions.js'
import getters from './moduleEventDashboardGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
